/**
 * Form honeypot guard.
 *
 * Pairs with snippets/form-honeypot.liquid. When a form is submitted, any
 * [data-hp-field] inside it is checked; if filled, submission is cancelled
 * silently (no error, no visual feedback) so the bot's classifier can't
 * tell that the submission was blocked.
 *
 * Listener is attached once, at the document level, so forms added later
 * by AJAX section renders (cart-notification, predictive-search results
 * pages, etc.) are still covered.
 */
(function () {
  if (typeof document === 'undefined') return;
  if (document.__reignFormHoneypotBound) return;
  document.__reignFormHoneypotBound = true;

  // Off-screen positioning lives here (not in a CSS file) so the rule is
  // guaranteed to be present even on pages that async-load CSS and would
  // otherwise flash the honeypot row during the brief FOUC window.
  // Applied via a single <style> injection so we don't paint layout for
  // .form-honeypot in the first frame.
  try {
    const style = document.createElement('style');
    style.textContent =
      '.form-honeypot{position:absolute!important;left:-9999px!important;' +
      'width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;}';
    document.head.appendChild(style);
  } catch (_) {}

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    const hp = form.querySelector('[data-hp-field]');
    if (!hp) return;
    if (!hp.value) return;
    // Filled → bot. Cancel silently and clear the field so the bot's
    // retry doesn't build evidence of a rejection pattern.
    event.preventDefault();
    event.stopPropagation();
    hp.value = '';
  }, true); // capture so we run before the form's own handlers
})();
